import type { TenantConfig } from '@/types/TenantConfig'

const white = '#ffffff'
const pink = '#d10075'
const darkGrey = '#3c3c3b'
const brown = '#4a3c31'

export const ltm: TenantConfig = {
  logo: 'assets/ltm/static/logo.svg',
  themeOptions: {
    primaryColor: pink,
    secondaryColor: brown,
    logoHeight: '65px',
    headerHeight: '115px',
    footerBackgroundColor: darkGrey,
    footerTextColor: white,
    dialog: {
      headerBackground: brown,
      headerTextColor: white,
      headerIconColor: white,
      headerBorder: '0',
    },
    cartHeaderBackgroundColor: darkGrey,
    cartHeaderTextColor: white,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/ltm/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-70px',
        mobile: '-50px',
      },
    },
  },
  teaserImageSize: {
    width: 320,
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: 'Payment Information',
      },
    },
  },
}
